import React from 'react';
import './FooterColors.css';
import { ColorTree } from '../../types';

function getColors(node: ColorTree, path: string[]): { path: string[]; color: string }[] {
  const childrenColors: { path: string[]; color: string }[] = Object.entries(node.folders || {})
    .map(([childName, childNode]) => getColors(childNode, path.concat(childName)))
    .flat();

  if (node.color) {
    return childrenColors.concat({
      path,
      color: node.color,
    });
  }
  return childrenColors;
}

type Props = {
  directoryColors: ColorTree;
};

const FooterColors = ({ directoryColors }: Props) => {
  const colors = getColors(directoryColors, []);
  return (
    <div className="footer-colors">
      <div className="footer__title">Colors:</div>
      {colors.map((color) => {
        const path = color.path.length ? color.path.join('/') : 'Total';
        const style = { backgroundColor: color.color };
        return (
          <div className="footer__pill footer-colors__color-item" key={path}>
            <div className="footer-colors__color-square" style={style} />
            {path}
          </div>
        );
      })}
    </div>
  );
};

export default FooterColors;
